module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_new05.381101f9.jpg";